import React from 'react';
import FullLogo from '../Photos/Fulllogo.png';
import GeneralImage from '../Photos/generalimage.jpg';
import Farm from '../Photos/Farm.jpg';

function About() {
  return (
    <div className="container mt-5">


      <h1 className="text-center" style={{ color: '#c92424' }}>About</h1>

      {/* Full-Width Image Section with Two Images */}
      <div className="row g-0 mb-5">
        <div className="col-12">
          <img src={Farm} alt="Full Width Image 1" className="img-fluid w-100" />
        </div>
        
      </div>

      {/* Full-Width Text Box */}
      <div className="get-in-touch-card mb-5 p-4">
        <div className="card-body">
          <h2 style={{ color: '#c92424' }}>How We Started</h2>
          <p className="card-text">
            Our welding business began on our 4th-generation family farm, where we first built bottomless feed bunks that were made to cost-effectively improve our calving operations. We continued to make fencing solutions for our own farm before realizing the potential of building for others. Since then, we have continued to grow to create long-lasting solutions for a variety of applications.  
          </p>
        </div>
      </div>

    


        {/* Google Maps and Address Section */}
      <div className="row mb-5">
        <div className="col-md-6">
          <h3 className="text-info mb-3">Find Us on the Map</h3>
          <iframe
            title="Google Map Location"
             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d137778.5034484805!2d-96.8170804273567!3d40.26456281736707!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x879642a907fb410b%3A0x92e39ab059d18d3d!2sBeatrice%2C%20NE%2068310!5e0!3m2!1sen!2sus!4v1756762112857!5m2!1sen!2sus" 
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
        <div className="col-md-6 d-flex flex-column">
          <h3 className="text-info mb-3">Contact Us</h3>
          <div className="card p-3 enlarged-address-card flex-grow-1">
            <p className="card-text">
              Location:<br />
             
              Beatrice, NE 68310<br />
              <br />
              <br />
              Email: eoltmans3@gmail.com<br />
              <br />
              Phone: (402) 239-4323
            </p>
          </div>
          <div className="flex-grow-1 mt-3">
            <img src={FullLogo} alt="Company Logo" className="img-fluid w-100" style={{ width: '100%', objectFit: 'cover' }} />
          </div>
        </div>
      </div>
    </div>

    
  );
}

export default About;
